(function () {
  /* ─── color-fit helpers ─── */
  function fitColorCircles(container) {
    if (container.classList.contains('expanded')) return;
    var circles = Array.from(container.querySelectorAll('.bestSellingColorCircle'));
    var badge = container.querySelector('.moreColors');
    if (!circles.length) return;
    circles.forEach(function (c) { c.style.display = ''; });
    if (badge) { badge.classList.remove('visible'); badge.style.display = 'none'; }
    var gap = parseFloat(getComputedStyle(container).gap) || 0;
    var containerW = container.clientWidth;
    var badgeW = badge ? (badge.offsetWidth || 38) + gap : 0;
    var used = 0;
    var hidden = 0;
    for (var i = 0; i < circles.length; i++) {
      var cw = circles[i].offsetWidth + gap;
      var needBadge = (circles.length - i) > 1;
      if (used + cw <= containerW && (!needBadge || !badge || used + cw + badgeW <= containerW || i === circles.length - 1)) {
        used += cw;
      } else {
        for (var j = i; j < circles.length; j++) { circles[j].style.display = 'none'; hidden++; }
        break;
      }
    }
    if (badge && hidden > 0) { badge.textContent = '+' + hidden; badge.style.display = ''; badge.classList.add('visible'); }
  }

  function expandColors(container) {
    var card = container.closest('.bestSellingCard');
    if (!card) return;
    var naturalTop = container.offsetTop;
    container.classList.add('expanded');
    container.style.top = naturalTop + 'px';
    card.classList.add('colors-expanded');
    var circles = Array.from(container.querySelectorAll('.bestSellingColorCircle'));
    circles.forEach(function (c) { c.style.display = ''; });
    var badge = container.querySelector('.moreColors');
    if (badge) { badge.style.display = 'none'; badge.classList.remove('visible'); }
  }

  function collapseColors(container) {
    var card = container.closest('.bestSellingCard');
    container.classList.remove('expanded');
    container.style.top = '';
    if (card) card.classList.remove('colors-expanded');
    fitColorCircles(container);
  }

  document.addEventListener('click', function (e) {
    var badge = e.target.closest('.moreColors.visible');
    if (badge) {
      e.preventDefault();
      e.stopPropagation();
      var container = badge.closest('.bestSellingColors');
      if (container) expandColors(container);
      return;
    }
    var collapseBtn = e.target.closest('.collapseColors');
    if (collapseBtn) {
      e.preventDefault();
      e.stopPropagation();
      var container = collapseBtn.closest('.bestSellingColors');
      if (container) collapseColors(container);
      return;
    }
  }, true);

  function initColorFit() {
    document.querySelectorAll('.bestSellingColors').forEach(function (c) { fitColorCircles(c); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initColorFit);
  } else {
    initColorFit();
  }
  /* styles.css loads async — a fit measured before it arrived is wrong; re-fit once everything is in */
  window.addEventListener('load', initColorFit);
  window.addEventListener('resize', function () {
    document.querySelectorAll('.bestSellingColors:not(.expanded)').forEach(function (c) { fitColorCircles(c); });
  });

  /* ─── hover / color-circle init ─── */
  function thumbToLarge(thumb) {
    if (!thumb) return null;
    var s = thumb.getAttribute('src') || '';
    return s.replace(/width=\d+/, 'width=400') || null;
  }

  /* Предзагрузка hover-фото (второе фото карточки + большое фото каждого кружка цвета).
     Раньше шла при init для всех карточек сразу: на телефоне это 82 лишних запроса
     width=400 (замер 06.10.2026), а hover там не существует. Теперь только там, где
     есть мышь, и только когда карточка попала в зону видимости (карусель — overflow,
     IntersectionObserver учитывает обрезку контейнером). Fallback без IO — первый mouseenter. */
  var CAN_HOVER = !!(window.matchMedia && window.matchMedia('(hover: hover)').matches);
  var preloadIO = (CAN_HOVER && 'IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      preloadIO.unobserve(en.target);
      runPreload(en.target);
    });
  }, { rootMargin: '200px' }) : null;
  function runPreload(card) {
    if (card._hgPreloaded) return;
    card._hgPreloaded = true;
    var hv = card.querySelector('.bestSellingImageHover');
    var hvPre = hv ? hv.getAttribute('src') : null;
    if (hvPre) (new Image()).src = hvPre;
    card.querySelectorAll('.bestSellingColorCircle').forEach(function (circle) {
      var large = thumbToLarge(circle.querySelector('img'));
      if (large) (new Image()).src = large;
      var img2 = circle.getAttribute('data-hover-image');
      if (img2) (new Image()).src = img2;
    });
  }
  function armPreload(card) {
    if (!CAN_HOVER) return;
    if (preloadIO) preloadIO.observe(card);
    else card.addEventListener('mouseenter', function () { runPreload(card); }, { once: true });
  }

  function initCard(card) {
    var defaultImg = card.querySelector('.bestSellingImageDefault');
    if (!defaultImg) return;

    // Card-level events — attach once
    if (!card.dataset.colorInit) {
      card.dataset.colorInit = '1';

      var imageBox = card.querySelector('.bestSellingImageBox');
      var hoverImg = card.querySelector('.bestSellingImageHover');
      var imageLink = card.querySelector('.bestSellingImageLink');
      var cardLinks = card.querySelectorAll('.bestSellingCardLink');
      var baseCardUrl = card.dataset.url;
      var originalSrc = defaultImg.getAttribute('src');

      defaultImg.style.opacity = '';
      if (hoverImg) {
        hoverImg.style.opacity = '';
        hoverImg.style.display = 'none';
      }

      card._hg = { active1: null, active2: null, activeUrl: null, origSrc: originalSrc, origSrcset: defaultImg.getAttribute('srcset') || '' };
      armPreload(card);

      if (imageBox) {
        imageBox.addEventListener('mouseenter', function () {
          var hv = card.querySelector('.bestSellingImageHover');
          var hvSrc = hv ? hv.getAttribute('src') : null;
          var newSrc = (card._hg.active2 || hvSrc) || card._hg.origSrc;
          defaultImg.srcset = '';
          defaultImg.src = newSrc;
        });
        imageBox.addEventListener('mouseleave', function () {
          var s = card._hg.active1 || card._hg.origSrc;
          defaultImg.srcset = s === card._hg.origSrc ? card._hg.origSrcset : '';
          defaultImg.src = s;
        });
      }

      card.addEventListener('click', function (e) {
        if (e.target.closest('.moreColors') || e.target.closest('.collapseColors') || e.target.closest('.bestSellingLikeIcon')) return;
        window.location.href = card._hg.activeUrl || card.dataset.url;
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          window.location.href = card._hg.activeUrl || card.dataset.url;
        }
      });
      card.addEventListener('mouseleave', function () {
        card._hg.active1 = null;
        card._hg.active2 = null;
        card._hg.activeUrl = null;
        defaultImg.srcset = card._hg.origSrcset;
        defaultImg.src = card._hg.origSrc;
        if (imageLink) imageLink.href = baseCardUrl;
        cardLinks.forEach(function (l) { l.href = baseCardUrl; });
      });
    }

    // Circle-level events — re-attach every call (supports hgBscInitCards after innerHTML update)
    card.querySelectorAll('.bestSellingColorCircle').forEach(function (circle) {
      if (circle.dataset.circleInit) return;
      circle.dataset.circleInit = '1';

      var il = card.querySelector('.bestSellingImageLink');
      var cls = card.querySelectorAll('.bestSellingCardLink');
      var bUrl = card.dataset.url;

      circle.addEventListener('mouseenter', function () {
        if (!card._hg) return;
        card._hg.active1 = thumbToLarge(circle.querySelector('img'));
        card._hg.active2 = circle.getAttribute('data-hover-image') || null;
        card._hg.activeUrl = circle.getAttribute('data-variant-url') || null;
        defaultImg.srcset = '';
        defaultImg.src = card._hg.active1 || card._hg.origSrc;
        var circleAlt = (circle.querySelector('img') || {}).alt || '';
        if (circleAlt) defaultImg.alt = circleAlt;
        var url = card._hg.activeUrl || bUrl;
        if (il) il.href = url;
        cls.forEach(function (l) { l.href = url; });
      });
      circle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var url = circle.getAttribute('data-variant-url');
        if (url) window.location.href = url;
      });
    });
  }

  function initAllCards() {
    document.querySelectorAll('.bestSellingCard').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCards);
  } else {
    initAllCards();
  }

  /* публичный API — секция home-recently-viewed вызывает после innerHTML */
  window.hgBscInitCards = initAllCards;
})();
